/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Payment_CardInputs */

const vi_receipt_payment_card = /** @type {(inputs: Receipt_Payment_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ`)
};

/**

* @param {Receipt_Payment_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_payment_card = /** @type {((inputs?: Receipt_Payment_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Payment_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_payment_card(inputs)
});